<template>
  <div class="q_pad_lr15px q_mar_t15px">
    <div class="q_po_re">
      <van-image class="q_speed_bg" fit="cover" :src="url" />
    </div>

    <div v-if="isShow" style="width:905px;height:640px;margin-left:auto;margin-right:auto;" class="zsbox" id="downdata"
         ref="exportPdf"
    >
      <div id="zs"
           :style="trainStyle"
      >
        <div class="p1"
             style="top: 340px;width: 100%;text-align: center;font-size: 40px;font-family: sans-serif;font-weight: bold;position: absolute;color: #fff;"
        >
          {{ certificate.userName }}
        </div>

        <div class="p1"
             style="left: 100px;top: 410px;font-family: sans-serif;font-size: 24px;position: absolute;color: #fff;
               width: 710px;line-height: 40px;"
        >
          在{{ formatDateMonth(certificate.grantTime) }}参加{{
            certificate.projectName
          }}活动，完成要求课时，表现优异。特发此证，以资鼓励!
        </div>

        <div class="p1" style="left:670px;top:580px;position: absolute;font-size: 18px;color: #fff;">
          {{ formatDate(certificate.grantTime) }}
        </div>

      </div>
    </div>


  </div>
</template>

<script>
import {certificateById, } from "@/api/certificate";
import {parseTime, wxCloseShare} from "@/utils/jiutang";
import zsbj3 from '@/assets/image/zsbj3.png'
import html2canvas from "html2canvas";

export default {
  name: 'Train',
  props: {
    msg: String
  },
  data() {
    return {
      certificateId: '',
      certificate: {},
      donation: {},
      trainStyle: 'position:relative;width:905px;height:640px;background:url(' + zsbj3 + ');background-size:905px 640px;margin-left:auto;margin-right:auto;',
      isShow:true,
      url :''
    }
  },
  created() {
    this.certificateId = this.$route.query.id;
    this.init()
  },
  methods: {
    /**
     * 页面初始化
     */
    init() {
      wxCloseShare()
      this.$modal.loading()
      //获取证书表信息
      certificateById(this.certificateId).then((res) => {
        this.certificate = res.data
      }).finally(() => {
        this.pdf()
        this.$modal.closeLoading()
      })
      //     .then(() => {
      //   //获取协会信息
      //   var param = {
      //     id: this.certificate.activity_id
      //   }
      //   console.log('param',param)
      //   listDonation(param).then(res => {
      //     console.log('resss',res)
      //     this.donation = res.rows[0]
      //     this.donation.createTime = res.rows[0].createTime.substring(0, 10)
      //     this.donation.percentage = ((res.rows[0].money / res.rows[0].sumMoney) * 100).toFixed(2)
      //   })
      // })
    },
    goToSpeeddea(id) {
      this.$router.push({
        path: '/home/Speeddea', query: {id: id}
      });
    },
    parseTime(time) {
      return parseTime(time, '{y}-{m}-{d}')
    },
    pdf(){
      html2canvas(this.$refs.exportPdf, {
        backgroundColor: '#ffffff',
        useCORS: true,
        // width: window.screen.availWidth,
        // height: window.screen.availHeight,
        windowHeight: document.body.scrollHeight,
        y: window.pageYOffset
      }).then((canvas) => {
        this.url = canvas.toDataURL()
        this.isShow = false
      })
    },
    formatDate(inputDate) {
      const date = new Date(inputDate)

      const year = date.getFullYear()
      const month = date.getMonth() + 1 // 月份从0开始，需要加1
      const day = date.getDate()

      // 使用模板字符串构建日期字符串
      const formattedDate = `${year}年${month < 10 ? month : month}月${day < 10 ? day : day}日`

      return formattedDate
    },
    formatDateMonth(inputDate) {
      const date = new Date(inputDate)

      const year = date.getFullYear()
      const month = date.getMonth() + 1 // 月份从0开始，需要加1
      const day = date.getDate()

      // 使用模板字符串构建日期字符串
      const formattedDate = `${year}年${month < 10 ? month : month}月份`

      return formattedDate
    }
  },
}
</script>
<style scoped="scoped">
.q_speed_img {
  width: 110px;
  height: 110px;
}

.q_speed_img >>> .van-image__img {
  border-radius: 5px;
}

.q_speed_b {
  background-color: #F2F3F7;
  width: 100%;
  height: 6px;
  border-radius: 3px;
  position: relative;
}

.q_speed_t {
  background-color: #FF5733;
  width: 10%;
  height: 6px;
  border-radius: 3px;
  position: absolute;
  top: 0px;
  left: 0;
}

.q_speed_bg {
  width: 100%;
}
</style>
